export default __webpack_public_path__ + "static/media/avatar_10_1.bc7bbf09.png";